export enum SiteEnvironments {
  JAG = 'JAG',
  HH = 'HH',
  OSH = 'OSH',
  POSH = 'POSH',
  SK = 'SK',
  GLOBAL = 'GLOBAL',
}
